export default {
    parent: 'ScormLayout', // the layout we'll be using
    url: '/scorm',
    abstract: true,
    template: '<ui-view></ui-view>'
};



// WEBPACK FOOTER //
// ./src/app/states/scorm/index.js